import { render } from "./PublishingInfo.vue?vue&type=template&id=e86b451a&scoped=true"
import script from "./PublishingInfo.vue?vue&type=script&lang=js"
export * from "./PublishingInfo.vue?vue&type=script&lang=js"

import "./PublishingInfo.vue?vue&type=style&index=0&id=e86b451a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e86b451a"]])

export default __exports__